import TableCell from '@tiptap/extension-table-cell';
import { findParentNodeOfType } from 'prosemirror-utils';

import { preventNewLinesInsideTable } from './shared';

export default TableCell.extend({
  addProseMirrorPlugins() {
    return [preventNewLinesInsideTable('table-cell')];
  },
  addKeyboardShortcuts() {
    return {
      Enter: ({ editor }) => {
        const { state, commands } = editor;

        if (!findParentNodeOfType(state.schema.nodes.tableCell)(state.selection)) {
          return false;
        }

        commands.setHardBreak();

        return true;
      },
    };
  },
});
